import { FaLaptopCode } from 'react-icons/fa';
import { ProjectsViewMain } from '../Components/ProjectsViewMain';

export const ProjectsModule = () => [{
    views: 'PRIVATE', path: '/dashboard/proyectos', component: <ProjectsViewMain />,
    roles: null, permissions: null, label: 'Proyectos', icon: <FaLaptopCode />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
